// This code removes define function which is defined in CSI FE
// and conflicts with libraries in iris-frontend
if (typeof window.define === 'function') {
  window.define = null;
}
